// @flow
import React from 'react';

import { NATIVE_INFERENCE_POOL_ID } from '../../../constants';
import { NativeInferencePoolEnabledContainer } from '../../native-inference-pool-top-level/native-inference-pool-details-inputs-section/NativeInferencePoolEnabledContainer';

export const NativeInferencePoolEnabledCellRenderer = (props) => {
  if (props.value == null) {
    return null;
  }
  const nativeInferencePoolId = props.data[NATIVE_INFERENCE_POOL_ID];
  return (
    <NativeInferencePoolEnabledContainer
      addLabel={false}
      checked={props.value}
      nativeInferencePoolId={nativeInferencePoolId}
    />
  );
};
